export { default } from "./DetailVideo";
export * from "./DetailVideo";
